/* tslint:disable */
/* eslint-disable */
/**
 * Litiverse API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  HTTPValidationError,
  Party,
  PartyCreate,
  PartyUpdate,
} from '../models/index';
import {
    HTTPValidationErrorFromJSON,
    HTTPValidationErrorToJSON,
    PartyFromJSON,
    PartyToJSON,
    PartyCreateFromJSON,
    PartyCreateToJSON,
    PartyUpdateFromJSON,
    PartyUpdateToJSON,
} from '../models/index';

export interface CreatePartyApiV1PartiesPostRequest {
    partyCreate: PartyCreate;
}

export interface CreatePartyApiV1PartiesPost0Request {
    partyCreate: PartyCreate;
}

export interface DeletePartyApiV1PartiesIdDeleteRequest {
    id: number;
}

export interface ReadPartiesApiV1PartiesGetRequest {
    skip?: number;
    limit?: number;
}

export interface ReadPartiesApiV1PartiesGet0Request {
    skip?: number;
    limit?: number;
}

export interface ReadPartyApiV1PartiesIdGetRequest {
    id: number;
}

export interface UpdatePartyApiV1PartiesIdPutRequest {
    id: number;
    partyUpdate: PartyUpdate;
}

/**
 * 
 */
export class PartiesApi extends runtime.BaseAPI {

    /**
     * Create new party.
     * Create Party
     */
    async createPartyApiV1PartiesPostRaw(requestParameters: CreatePartyApiV1PartiesPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Party>> {
        if (requestParameters['partyCreate'] == null) {
            throw new runtime.RequiredError(
                'partyCreate',
                'Required parameter "partyCreate" was null or undefined when calling createPartyApiV1PartiesPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/v1/parties/`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PartyCreateToJSON(requestParameters['partyCreate']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PartyFromJSON(jsonValue));
    }

    /**
     * Create new party.
     * Create Party
     */
    async createPartyApiV1PartiesPost(requestParameters: CreatePartyApiV1PartiesPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Party> {
        const response = await this.createPartyApiV1PartiesPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create new party.
     * Create Party
     */
    async createPartyApiV1PartiesPost_1Raw(requestParameters: CreatePartyApiV1PartiesPost0Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Party>> {
        if (requestParameters['partyCreate'] == null) {
            throw new runtime.RequiredError(
                'partyCreate',
                'Required parameter "partyCreate" was null or undefined when calling createPartyApiV1PartiesPost_1().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/v1/parties`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PartyCreateToJSON(requestParameters['partyCreate']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PartyFromJSON(jsonValue));
    }

    /**
     * Create new party.
     * Create Party
     */
    async createPartyApiV1PartiesPost_1(requestParameters: CreatePartyApiV1PartiesPost0Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Party> {
        const response = await this.createPartyApiV1PartiesPost_1Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete a party.
     * Delete Party
     */
    async deletePartyApiV1PartiesIdDeleteRaw(requestParameters: DeletePartyApiV1PartiesIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Party>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deletePartyApiV1PartiesIdDelete().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/parties/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PartyFromJSON(jsonValue));
    }

    /**
     * Delete a party.
     * Delete Party
     */
    async deletePartyApiV1PartiesIdDelete(requestParameters: DeletePartyApiV1PartiesIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Party> {
        const response = await this.deletePartyApiV1PartiesIdDeleteRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieve parties.
     * Read Parties
     */
    async readPartiesApiV1PartiesGetRaw(requestParameters: ReadPartiesApiV1PartiesGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Party>>> {
        const queryParameters: any = {};

        if (requestParameters['skip'] != null) {
            queryParameters['skip'] = requestParameters['skip'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/parties/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(PartyFromJSON));
    }

    /**
     * Retrieve parties.
     * Read Parties
     */
    async readPartiesApiV1PartiesGet(requestParameters: ReadPartiesApiV1PartiesGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Party>> {
        const response = await this.readPartiesApiV1PartiesGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieve parties.
     * Read Parties
     */
    async readPartiesApiV1PartiesGet_2Raw(requestParameters: ReadPartiesApiV1PartiesGet0Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Party>>> {
        const queryParameters: any = {};

        if (requestParameters['skip'] != null) {
            queryParameters['skip'] = requestParameters['skip'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/parties`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(PartyFromJSON));
    }

    /**
     * Retrieve parties.
     * Read Parties
     */
    async readPartiesApiV1PartiesGet_2(requestParameters: ReadPartiesApiV1PartiesGet0Request = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Party>> {
        const response = await this.readPartiesApiV1PartiesGet_2Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get party by ID.
     * Read Party
     */
    async readPartyApiV1PartiesIdGetRaw(requestParameters: ReadPartyApiV1PartiesIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Party>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling readPartyApiV1PartiesIdGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/parties/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PartyFromJSON(jsonValue));
    }

    /**
     * Get party by ID.
     * Read Party
     */
    async readPartyApiV1PartiesIdGet(requestParameters: ReadPartyApiV1PartiesIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Party> {
        const response = await this.readPartyApiV1PartiesIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update a party.
     * Update Party
     */
    async updatePartyApiV1PartiesIdPutRaw(requestParameters: UpdatePartyApiV1PartiesIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Party>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updatePartyApiV1PartiesIdPut().'
            );
        }

        if (requestParameters['partyUpdate'] == null) {
            throw new runtime.RequiredError(
                'partyUpdate',
                'Required parameter "partyUpdate" was null or undefined when calling updatePartyApiV1PartiesIdPut().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/v1/parties/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: PartyUpdateToJSON(requestParameters['partyUpdate']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PartyFromJSON(jsonValue));
    }

    /**
     * Update a party.
     * Update Party
     */
    async updatePartyApiV1PartiesIdPut(requestParameters: UpdatePartyApiV1PartiesIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Party> {
        const response = await this.updatePartyApiV1PartiesIdPutRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
